import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SmartImg from "@/lib/img";
import Reveal from "@/components/Reveal";

const TEASERS = [
  { title: "Our Rabbi", desc: "Meet Rabbi Alan R. Bell, our spiritual leader.", to: "/rabbi", image: "/img/firstparty/alan.webp" },
  { title: "Groups & Circles", desc: "Clubs, classes and small groups for every age and stage.", to: "/groups", image: "/img/firstparty/featureboxfridaynights.webp" },
  { title: "Memories", desc: "Photo albums and films from a century of celebrations.", to: "/memories", image: "/img/firstparty/img_1788-r.webp" },
  { title: "News", desc: "The latest happenings from Beth El.", to: "/news", image: "/img/firstparty/oq2it9se_new-banner-for-havana-night.webp" },
  { title: "Our Story", desc: "A hundred years of Jewish life in West Palm Beach.", to: "/story", image: "/img/firstparty/sliderhaftorah.webp" },
  { title: "Contact", desc: "Say shalom — visit, call or write to us.", to: "/contact", image: "/img/firstparty/dsc_5926-r.webp" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function ExploreTeasers() {
  return (
    <section id="explore" data-testid="explore-teasers-section" className="py-32 md:py-48 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="mb-14 md:mb-20">
          <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase text-gold mb-4">Explore Beth El</p>
          <h2 className="font-syne font-bold uppercase tracking-tighter leading-[0.95] text-4xl md:text-6xl">
            There&rsquo;s more to <span className="text-gold">see</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEASERS.map((t, i) => (
            <Reveal key={t.to} delay={0.05 * i}>
              <Link
                to={t.to}
                data-testid={`explore-teaser-${slug(t.title)}`}
                className="group relative block h-44 md:h-48 overflow-hidden border border-white/10 bg-surface/40 hover:border-gold/60 transition-colors duration-500 p-6 md:p-8"
              >
                <div className="absolute inset-0 overflow-hidden">
                  <SmartImg
                    src={t.image}
                    sizes="(max-width: 768px) 100vw, 33vw"
                    alt=""
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover opacity-40 transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" />
                </div>
                <ArrowUpRight
                  size={20}
                  className="absolute top-6 right-6 text-gold transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
                <div className="relative h-full flex flex-col justify-end">
                  <h3 className="font-syne font-bold uppercase tracking-tight text-lg md:text-xl group-hover:text-gold transition-colors duration-400">{t.title}</h3>
                  <p className="mt-2 text-sm text-foreground/60">{t.desc}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
